import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.table)?_c(VCard,[_c(VCardTitle,{style:(_vm.getThemeStyle)},[_vm._v(" "+_vm._s(_vm.title)+" "),_c(VSpacer),_c(VTextField,{attrs:{"dark":"","append-icon":"mdi-magnify","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"items-per-page":_vm.itemsPerPage}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }